import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import Iconify from '../components/iconify';

import { useNavigate } from 'react-router-dom';
import { QuestionsTable } from 'src/components/pickem-admin/QuestionsTable';
import { useGetPickem } from '@/api/pickems/getPickem.ts';
import { useAppSearchParams } from '@/hooks/useAppSearchParams.ts';
import { OptionUIType, Pickem, SelectionType } from '@/@types/api.types.ts';
import { useGetUserSelectionsQuery } from '@/api/pickems/getUserSelections.ts';

export default function UserSelectionsPage() {
  const navigate = useNavigate();
  const [state, setState] = useState({
    title_en: '',
    title_fr: '',
    questions: [],
  } as unknown as Pickem);

  const { pickemId, userId } = useAppSearchParams();

  const { data: pickem, isLoading: isLoadingGetPickem } =
    useGetPickem(pickemId);
  const { data: selections, isLoading: isLoadingGetSelections } =
    useGetUserSelectionsQuery({ pickemId, userId });

  useEffect(() => {
    if (!pickem || !selections?.length) return;

    const pickemWithSelections = mergeUserSelections(pickem, selections);
    setState(pickemWithSelections);
  }, [pickem, selections]);

  const mergeUserSelections = (
    pickem: Pickem,
    userSelections: SelectionType[]
  ) => {
    const tiebreaker = userSelections.find((item) => item.option_id === 0);
    pickem.questions = pickem.questions.map((question) => {
      if (question.question_id === tiebreaker?.question_id) {
        question.custom_value = tiebreaker.custom_value;
        return question;
      }
      question.options = question.options.map((option) => {
        const userQuestionSelections = userSelections.find(
          (selection) => selection.question_id === question.question_id
        );
        if (!userQuestionSelections) return option;

        if (userQuestionSelections.custom_value) {
          option.custom_value = userQuestionSelections.custom_value;
        }

        return {
          ...option,
          isSelected: userQuestionSelections.option_id === option.option_id,
        } as OptionUIType;
      });

      return question;
    });

    return pickem;
  };

  return (
    <>
      <Helmet>
        <title> User Selections </title>
      </Helmet>

      <Container>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          mb={5}
        >
          <Typography variant='h4' gutterBottom>
            User Selections
          </Typography>

          <Box>
            <Button
              variant='outlined'
              startIcon={<Iconify icon='eva:chevron-left-outline' />}
              onClick={() => navigate(`/dashboard/pickems`)}
              sx={{ mr: 2 }}
            >
              BACK
            </Button>
          </Box>
        </Stack>

        <Card sx={{ padding: 4, marginBottom: 4 }}>
          <Typography variant='h5' sx={{ marginBottom: 2 }}>
            User Selections
          </Typography>
          {isLoadingGetPickem || isLoadingGetSelections ? (
            <Box
              sx={{ display: 'flex', justifyContent: 'center' }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              <QuestionsTable
                lang='en'
                questions={state.questions}
                showActions={false}
              />
            </>
          )}
        </Card>
      </Container>
    </>
  );
}
